var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"px-6 py-3 text-xl font-semibold transition-all border-2 border-white rounded-full md:font-medium md:px-8 whitespace-nowrap",class:{
    'md:text-3xl': _vm.big,
    'cursor-not-allowed text-gray-400 border-gray-400': _vm.disabled,
    'bg-brand-primary hover:bg-transparent hover:text-brand-primary hover:border-brand-primary': !_vm.disabled
  },attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }